import(/* webpackMode: "eager" */ "/workspace/apps/home-webapp/src/app/(pages)/rtu/@section6/page.tsx");
